import { makeStyles } from '@material-ui/core';

const styles = makeStyles(() => ({
  modal: {
    display: 'flex',
    justifyContent: 'space-between',
    '& button': {
      margin: '0px 2px',
      width:90
    },
  },
}));

export default styles;
